import { PeriodToggleButton, PeriodToggleContainer } from "../../styles/dashboard";

const PeriodToggle: React.FC<{
  selectedPeriod: string;
  onPeriodChange: (period: string) => void;
}> = ({ selectedPeriod, onPeriodChange }) => {
  return (
    <PeriodToggleContainer>
      <PeriodToggleButton
        $active={selectedPeriod === "Weekly"}
        onClick={() => onPeriodChange("Weekly")}
      >
        Weekly
      </PeriodToggleButton>
      <PeriodToggleButton
        $active={selectedPeriod === "Monthly"}
        onClick={() => onPeriodChange("Monthly")}
      >
        Monthly
      </PeriodToggleButton>
    </PeriodToggleContainer>
  );
};

export default PeriodToggle;